import { ICycleFactory } from '../../entities/cycle/Cycle'
import { parseDateTime } from '../../utils/parse-date'
import castListItems from '../castListItems'
import { IOrderResponse, transformOrder } from '../order/OrderTransformer'

export interface ICycleResponse {
    cycle_info: {
        cycle_id: number // 10,
        code: string // 'Cycle1',
        name: string // 'Cycle1',
        order_from: string // '14/03/2022 18:00',
        order_to: string // '15/03/2022 08:00',
        days_before_1: number // 1,
        days_before_2: number // 0,
        delivery_from: string // '15/03/2022 08:00',
        delivery_to: string // '15/03/2022 14:00',
        delivery_after_1: number // 0,
        delivery_after_2: number // 0,
        pickup_from: string // '14/03/2022 08:00',
        pickup_to: string // '14/03/2022 14:00',
        pickup_x: number // 120,
        number_of_orders: number // 1,
        number_orders_labeled: number // 1
        number_products: number // 2,
        number_products_ready: number // 0,
        number_open_orders: number // 1,
        number_products_labeled: number // 0
        total_number_open_orders: number // 2
        total_number_products: number // 4
        total_number_products_labeled: number // 5
    }
    orders: IOrderResponse[]
}

function addSixHours(dateTimeStr: string) {
    // Разбиваем строку на дату и время
    const [datePart, timePart] = dateTimeStr.split(' ')
    const [day, month, year] = datePart.split('/').map(Number)
    const [hours, minutes] = timePart.split(':').map(Number)

    // Создаем объект Date (месяц в JS начинается с 0, поэтому вычитаем 1)
    const date = new Date(year, month - 1, day, hours, minutes)

    // Добавляем 6 часов
    date.setHours(date.getHours() + 6)

    // Форматируем обратно в нужный формат
    const newDay = String(date.getDate()).padStart(2, '0')
    const newMonth = String(date.getMonth() + 1).padStart(2, '0')
    const newYear = date.getFullYear()
    const newHours = String(date.getHours()).padStart(2, '0')
    const newMinutes = String(date.getMinutes()).padStart(2, '0')

    return `${newDay}/${newMonth}/${newYear} ${newHours}:${newMinutes}`
}

export const transformCycle = (cycle: ICycleResponse): ICycleFactory => {
    return {
        code: cycle.cycle_info.code,
        name: cycle.cycle_info.name,

        numberOfOrders: cycle.cycle_info.number_of_orders,
        numberOfOrdersLabeled: cycle.cycle_info.number_orders_labeled,
        numberOfOpenOrders: cycle.cycle_info.number_open_orders,
        totalNumberOfOpenOrders: cycle.cycle_info.total_number_open_orders,
        numberOfProducts: cycle.cycle_info.number_products,
        numberOfProductsLabeled: cycle.cycle_info.number_products_labeled,
        numberOfProductsReady: cycle.cycle_info.number_products_ready,

        pickupFrom: parseDateTime(cycle.cycle_info.pickup_from, 3), // (GMT+03:00) Иерусалим

        // ILYA TEST DATA REPLACE WHEN BACKEND WILL BE READY
        pickupTo: parseDateTime(
            cycle.cycle_info.pickup_to ||
                addSixHours(cycle.cycle_info.pickup_from),
            3
        ), // (GMT+03:00) Иерусалим
        pickupX: cycle.cycle_info.pickup_x || 120, // (GMT+03:00) Иерусалим
        // TEST DATA REPLACE WHEN BACKEND WILL BE READY

        orders: castListItems(cycle.orders, transformOrder),

        totalNumberProducts: cycle.cycle_info.total_number_products,
        totalNumberProductsLabeled:
            cycle.cycle_info.total_number_products_labeled,
    }
}
